import { render, staticRenderFns } from "./ProductEditSellPrices.vue?vue&type=template&id=298a858c"
import script from "./ProductEditSellPrices.vue?vue&type=script&lang=ts"
export * from "./ProductEditSellPrices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298a858c')) {
      api.createRecord('298a858c', component.options)
    } else {
      api.reload('298a858c', component.options)
    }
    module.hot.accept("./ProductEditSellPrices.vue?vue&type=template&id=298a858c", function () {
      api.rerender('298a858c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditSellPrices.vue"
export default component.exports